<!-- 试卷列表 -->
<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>学术系统</el-breadcrumb-item>
      <el-breadcrumb-item>试卷管理</el-breadcrumb-item>
    </el-breadcrumb>
    <el-page-header @back="goBack"></el-page-header>
    <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
      <el-tab-pane label="练习题" name="3">
        <ExercisePaper ref="ExercisePaper"></ExercisePaper>
      </el-tab-pane>
      <el-tab-pane label="自定义试卷" name="1">
        <FormPaper ref="FormPaper"></FormPaper>
      </el-tab-pane>
      <el-tab-pane label="现场答题试卷" name="2">
        <NationalPaper ref="NationalPaper"></NationalPaper>
      </el-tab-pane>
    </el-tabs>

  </div>
</template>
<script>
import FormPaper from './components/form_paper.vue'
import NationalPaper from './components/national_paper.vue'
import ExercisePaper from './components/exercise_paper.vue'

export default {
  components: {
    FormPaper,
    NationalPaper,
    ExercisePaper
  },
  data () {
    return {
      activeName: '3'
    }
  },
  created () {
    this.activeName = this.$route.query.type || '3'
    this.handleClick()
  },
  methods: {
    goBack () {
      this.$router.push('/academic_Management/rh')
    },
    handleClick () {
      setTimeout(() => {
        switch (this.activeName) {
          case '1':
            this.$refs.FormPaper.init()
            break
          case '2':
            this.$refs.NationalPaper.init()
            break
          case '3':
            this.$refs.ExercisePaper.init()
            break
        }
      })
    }
  }
}
</script>
<style scoped lang="less">
/deep/ .el-tabs__header{
  margin-bottom: 0;
}
/deep/ .el-tabs__item{
  background-color: #fff;
  border-radius: 8px 8px 0 0;
  border: none;
}
/deep/ .el-tabs__header .el-tabs__nav{
  border-color: transparent;
}
/deep/ .el-tabs__item.is-active{
  background-color: #409EFF;
  color: #fff;
}
.default{
  height: calc(100vh - 220px);
  background-color: #fff;
}
</style>
